import React, { useState } from 'react';
import { RemoteAlertGroup } from '../types/remoteAlerts';
import { useGetRemoteAlertGroupsQuery, useDeleteRemoteAlertGroupMutation } from '../services/dataApi';
import RemoteAlertGroupTable from '../components/remotealerts/RemoteAlertGroupTable';
import RemoteAlertGroupDialog from '../components/remotealerts/RemoteAlertGroupDialog';

const RemoteAlertsPage: React.FC = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [editingGroup, setEditingGroup] = useState<RemoteAlertGroup | undefined>(undefined);
  const { data: alertGroups = [], isLoading, isError, error, refetch } = useGetRemoteAlertGroupsQuery();
  const [deleteRemoteAlertGroup] = useDeleteRemoteAlertGroupMutation();

  const handleOpenAddDialog = () => {
    setEditingGroup(undefined);
    setIsDialogOpen(true);
  };

  const handleOpenEditDialog = (group: RemoteAlertGroup) => {
    setEditingGroup(group);
    setIsDialogOpen(true);
  };

  const handleSaveGroup = () => {
    setIsDialogOpen(false);
    setEditingGroup(undefined);
    refetch(); // Optionally refetch after save
  };

  const handleDeleteGroup = async (groupId: string) => {
    if (window.confirm('Are you sure you want to delete this alert group?')) {
      try {
        await deleteRemoteAlertGroup(Number(groupId)).unwrap();
      } catch (e) {
        alert('Failed to delete alert group.');
      }
    }
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4 text-white">Remote Alert Groups</h1>
      {isLoading && <div className="text-gray-200">Loading alert groups...</div>}
      {isError && (
        <div className="text-red-400">
          Error loading alert groups: {
            error && typeof error === 'object'
              ? ('status' in error
                  ? `Status: ${error.status}`
                  : JSON.stringify(error))
              : String(error || 'Unknown error')
          }
        </div>
      )}
      {!isLoading && !isError && (
        <RemoteAlertGroupTable
          alertGroups={alertGroups.map((group: any) => ({
            ...group,
            sensorIds: Array.isArray(group.sensors) ? group.sensors : (Array.isArray(group.sensorIds) ? group.sensorIds : []),
          }))}
          onAddGroup={handleOpenAddDialog}
          onEditGroup={handleOpenEditDialog}
          onDeleteGroup={handleDeleteGroup}
        />
      )}
      {isDialogOpen && (
        <RemoteAlertGroupDialog
          group={editingGroup}
          onClose={() => setIsDialogOpen(false)}
          onSave={async (newGroup) => {
            if (editingGroup) {
              try {
                await deleteRemoteAlertGroup(Number(editingGroup.id)).unwrap();
              } catch (e) {
                alert('Failed to delete old alert group after editing.');
              }
            }
            handleSaveGroup();
            setTimeout(() => {
              refetch();
            }, 1000);
          }}
        />
      )}
    </div>
  );
};

export default RemoteAlertsPage; 